export const indexName = (environment: string, indexName: string): string =>
  `${environment}_${indexName}`;
